/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-46de7b2e.js';
import React from 'react';
import classNames from 'classnames';
import useConfig from '../../hooks/useConfig.js';
import { extractTimeObj } from '../../_common/js/date-picker/utils.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-fdce1f4f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-c00532d4.js';

var DatePickerCell = function DatePickerCell(props) {
  var _classNames;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var cellClass = classNames("".concat(classPrefix, "-date-picker__cell"), (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--now"), props.now), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--active"), props.active), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--disabled"), props.disabled), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--highlight"), props.highlight), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--hover-highlight"), props.hoverHighlight), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--active-start"), props.startOfRange), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--active-end"), props.endOfRange), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--hover-start"), props.hoverStartOfRange), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--hover-end"), props.hoverEndOfRange), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--additional"), props.additional), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--first-day-of-month"), props.firstDayOfMonth), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--last-day-of-month"), props.lastDayOfMonth), _defineProperty(_classNames, "".concat(classPrefix, "-date-picker__cell--week-of-year"), props.weekOfYear), _classNames));
  function handleClick(e) {
    var _props$onClick;
    if (props.disabled) return;
    if (props.time) {
      var _extractTimeObj = extractTimeObj(props.time),
        hours = _extractTimeObj.hours,
        minutes = _extractTimeObj.minutes,
        seconds = _extractTimeObj.seconds,
        milliseconds = _extractTimeObj.milliseconds,
        meridiem = _extractTimeObj.meridiem;
      var nextHours = hours;
      if (/am/i.test(meridiem) && nextHours === 12) nextHours -= 12;
      if (/pm/i.test(meridiem) && nextHours < 12) nextHours += 12;
      props.value.setHours(nextHours);
      props.value.setMinutes(minutes);
      props.value.setSeconds(seconds);
      props.value.setMilliseconds(milliseconds);
    }
    (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, props.value, {
      e: e
    });
  }
  function handleMouseEnter() {
    var _props$onMouseEnter;
    if (props.disabled) return;
    if (props.time) {
      var _extractTimeObj2 = extractTimeObj(props.time),
        hours = _extractTimeObj2.hours,
        minutes = _extractTimeObj2.minutes,
        seconds = _extractTimeObj2.seconds,
        milliseconds = _extractTimeObj2.milliseconds,
        meridiem = _extractTimeObj2.meridiem;
      var nextHours = hours;
      if (/am/i.test(meridiem) && nextHours === 12) nextHours -= 12;
      if (/pm/i.test(meridiem) && nextHours < 12) nextHours += 12;
      props.value.setHours(nextHours);
      props.value.setMinutes(minutes);
      props.value.setSeconds(seconds);
      props.value.setMilliseconds(milliseconds);
    }
    (_props$onMouseEnter = props.onMouseEnter) === null || _props$onMouseEnter === void 0 ? void 0 : _props$onMouseEnter.call(props, props.value);
  }
  return /* @__PURE__ */React.createElement("td", {
    className: cellClass,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-date-picker__cell-inner")
  }, props.text));
};
DatePickerCell.displayName = "DatePickerCell";

export { DatePickerCell as default };
//# sourceMappingURL=Cell.js.map
